import { useNetworkStatusStore } from '../stores/networkStatusStore'

export function markNetworkReachable(): void {
  useNetworkStatusStore.getState().setOffline(false)
}

export function markNetworkUnreachable(): void {
  useNetworkStatusStore.getState().setOffline(true)
}

export function initNetworkStatusListeners(): () => void {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return () => undefined
  }

  const sync = (): void => {
    useNetworkStatusStore.getState().setOffline(!window.navigator.onLine)
  }
  sync()
  window.addEventListener('online', sync)
  window.addEventListener('offline', sync)
  return () => {
    window.removeEventListener('online', sync)
    window.removeEventListener('offline', sync)
  }
}
